module.exports = __webpack_public_path__ + "fonts/karla-regular-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Karla/karla-regular-webfont.ttf
// module id = 3430
// module chunks = 0